// extracted by mini-css-extract-plugin
export default {"lecture":"Lecture_lecture__-LauQ","title":"Lecture_title__4bs3S","description":"Lecture_description__AyLCY","actions":"Lecture_actions__uEYH-"};